import * as shopifyThemeImages from '@shopify/theme-images';
import {curry, flip} from 'ramda'

/**
 * @param size
 * @param url
 */

const getSizedImage = curry(flip(shopifyThemeImages.getSizedImageUrl))

export default getSizedImage